'use client';

import { ReactNode } from 'react';
import { Box, Center, Stack, Heading, Link, HStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Text } from './Text';

const ListItems = [
    {
        title: 'outbank',
        items: [
            { trans: 'footer.outbank.features', href: 'https://outbankapp.com/features' },
            { trans: 'footer.outbank.security', href: 'https://outbankapp.com/sicherheit' },
            { trans: 'footer.outbank.banks', href: 'https://outbankapp.com/deine-banken' },
            { trans: 'footer.outbank.invite', href: 'https://outbankapp.com/freunde-werben-freunde' },
        ],
    },
    {
        title: 'footer.support.title',
        items: [
            {
                trans: 'footer.support.setup',
                href: 'https://outbankapp.com/outbank-app-einrichten-konten-hinzufuegen',
            },
            { trans: 'footer.support.faq', href: 'https://help.outbankapp.com/de/kb' },
            { trans: 'footer.support.blog', href: 'https://outbankapp.com/blog' },
            {
                trans: 'footer.support.security',
                href: 'https://outbankapp.com/wp-content/uploads/outbank-security-whitepaper.pdf',
            },
        ],
    },
    {
        title: 'footer.company.title',
        items: [
            { trans: 'footer.company.about', href: 'https://outbankapp.com/ueber-outbank' },
            { trans: 'footer.company.jobs', href: 'https://outbankapp.com/jobs-karriere' },
            { trans: 'footer.company.press', href: 'https://outbankapp.com/presse' },
            { trans: 'footer.company.data', href: 'https://outbankapp.com/datenschutz' },
            { trans: 'footer.company.impressum', href: 'https://outbankapp.com/impressum/' },
            { trans: 'footer.company.agb', href: 'https://outbankapp.com/agb/' },
        ],
    },
    {
        title: 'footer.partner.title',
        items: [
            { trans: 'footer.partner.friends', href: 'https://outbankapp.com/freunde-werben-freunde' },
            { trans: 'footer.partner.affiliate', href: 'https://outbankapp.com/affiliate' },
        ],
    },
];

const ListHeader = ({ children }: { children: ReactNode }) => {
    return (
        <Heading fontSize="large" color="white" lineHeight={1.5} mb={2}>
            {children}
        </Heading>
    );
};

interface Props {
    boxSize: number;
    paddingTop: number;
    paddingBottom: number;
}

export const Footer = (props: Props) => {
    const { boxSize: _boxWith, paddingTop, paddingBottom } = props;
    const { t } = useTranslation();
    let boxSize = _boxWith / 4;
    const spacing = boxSize * 0.1;
    boxSize = boxSize - spacing;
    return (
        <Box paddingTop={paddingTop} paddingBottom={paddingBottom} bg="brand.100">
            <Center>
                <HStack wrap="wrap" spaceY={3} align="baseline">
                    {ListItems.map((item) => {
                        return (
                            <Stack w={boxSize} gap="0.2rem">
                                <ListHeader>{t(item.title)}</ListHeader>
                                {item.items.map((item) => {
                                    return (
                                        <Link color="white" href={item.href} target="_blank">
                                            <Text trans={item.trans}/>
                                        </Link>
                                    );
                                })}
                            </Stack>
                        );
                    })}
                </HStack>
            </Center>
        </Box>
    );
};
